import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


const rootElement = document.getElementById('root');
rootElement.setAttribute('translate', 'no');
rootElement.classList.add('notranslate');
document.documentElement.lang = 'ru';
const root = ReactDOM.createRoot(rootElement);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);